import React from 'react';
import { Link } from 'react-router-dom';
import './OurCommitment.css';

const OurCommitment = () => {
    return (
        <section className="commitment-section">
            <div className="commitment-container">
                <div className="commitment-left">
                    <span className="section-subtitle light-text">OUR COMMITMENT</span>
                    <h2 className="commitment-title">
                        Engineered for Reliable<br />
                        Physiotherapy Care
                    </h2>
                    <Link to="/services" className="btn-light">DISCOVER OUR APPROACH</Link>
                </div>

                <div className="commitment-right">
                    <p className="commitment-desc">
                        Prime Rehab Industries manufactures high-quality physiotherapy and rehabilitation equipment designed for hospitals, clinics, and therapy centers. Our products are engineered for durability, smooth functionality, and patient comfort to support effective physiotherapy treatments.
                    </p>

                    <div className="commitment-gallery">
                        <div className="gallery-img1">
                            <img
                                src="https://primerehab.ascentbw.com/Image/About/Abt1.png"
                                alt="Rehabilitation Room"
                            />
                        </div>
                        <div className="gallery-img">
                            <img
                                src="https://primerehab.ascentbw.com/Image/About/Abt2.png"
                                alt="Treatment Bed"
                            />
                            <p className="gallery-caption">
                                Our equipment is built using strong metal frames, precision engineering, and comfortable rexine upholstery to ensure long-lasting performance in daily clinical use.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default OurCommitment;
